import styled from 'styled-components';

export const RnRTabContent = styled.section`
  padding-top: 2rem;
`;

export const ReviewWrap = styled.section`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 1rem 0;
`;
export const RnRUserReviewBlockWrap = styled.div`
  width: 49%;
`;
export const RatingSummary = styled.section`
  display: flex;
  flex-direction: row;
  border: 1px solid #eff3f8;
  border-radius: 0.5rem;
`;
export const ReviewTabsWrap = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;
export const ReviewTab = styled.div`
  border-radius: 3rem;
  display: flex;
  flex-direction: row;
  font-size: 1.2rem;
  align-items: center;
  margin-right: 1rem;
  margin-bottom: 1rem;
  span {
    padding: 0 1rem;
  }
  ${({primary, secondary}) => {
    switch (true) {
      case primary:
        return `background-color : #ddede5; color: #18a160`;
      case secondary:
        return `background-color : #ffeef1; color: #ff3a5c`;
    }
  }}
`;

export const NumberOfReview = styled.div`
  width: 2.4rem;
  height: 2.4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: bold;
  font-size: 1.2rem;
  border-radius: 50%;
  ${({primary, secondary}) => {
    switch (true) {
      case primary:
        return `background-color : #18a160`;
      case secondary:
        return `background-color : #ff3a5c`;
    }
  }}
`;
export const UserReviewSummary = styled.div`
  width: 35%;
  padding: 2rem;
  border-left: 1px solid #eff3f8;
  p {
    padding-bottom: 1rem;
  }
  &:first-child {
    border-right: 1px solid #e1e1e1;
  }
`;
export const PopupButton = styled.div(
  props => `
    width: 100%;
    cursor: pointer;
    font-size: 1.4rem;
    color: #2276e3;
    font-weight: bold;
    padding: 1rem 1rem 0;
    text-align: center;
    border-top: 1px solid #eff3f8;
    font-family:${props.theme.font.fontFamily};
`,
);
